import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqs } from '../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="white" eyebrow="Antes de decidir" title="Preguntas frecuentes" data-id="element-46" data-mp="1gcpfsz39k8rr">
      <ul className="mx-auto max-w-narrow space-y-3" data-id="element-47" data-mp="1gaurdass9yix">
        {faqs.map((faq, index) => {
        const isOpen = open === index;
        return <li key={faq.question} className="overflow-hidden rounded-2xl bg-white shadow-soft ring-1 ring-gray-200" data-id="element-48" data-mp="292eidgvmggvh" data-mpi={index}>
              <h3 data-id="element-49" data-mp="1z3732o5buc5q">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors duration-150 ease-calm hover:bg-rose-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-rose-200 md:px-7" data-id="element-50" data-mp="1z3oxrgcccibj">
                  <span className="font-display text-lg font-extrabold tracking-tight text-ink" data-id="element-51" data-mp="ufzh9w2sxl15">
                    {faq.question}
                  </span>
                  <PlusIcon className={`h-5 w-5 shrink-0 text-rose-600 transition-transform duration-200 ease-calm ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-52" data-mp="kiuupv51nnjt" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-53" data-mp="3sywmxyjrhyah">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-54" data-mp="3swtsn2bktizy">
                    <p className="px-5 pb-6 text-lg leading-relaxed text-gray-500 md:px-7" data-id="element-55" data-mp="1uhw7utn6oem0">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}